
import React from "react";
import moment from 'moment/moment';

class DateFormatter {

    intToDate = (intDate) => {
        // YYYYMMDD formatındaki tarihi ayrıştırma
        const year = intDate / 10000 | 0;
        const month = (intDate % 10000 / 100 | 0) - 1; // Ay 0'dan başlar, bu yüzden 1 çıkartıyoruz
        const day = intDate % 100;

        // Tarih objesi oluşturma
        const formattedDate = new Date(year, month, day);

        // Tarihi istediğiniz formatta formatlama
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedString = formattedDate.toLocaleDateString('tr-TR', options);

        return formattedString;
    };

    dateToInt = (date) => {
        // Tarih objesinden YYYYMMDD formatında tarih oluşturma
        date = moment(date).format('DD/MM/YYYY');
        const [day, month, year] = date.split("/");
        const formattedDate = `${year}${month.padStart(2, '0')}${day.padStart(2, '0')}`;
        const integerDate = parseInt(formattedDate);
        console.log(integerDate);
        return integerDate
    };

    timestampToDate = (timestamp) => {
        // Unix timestamp'i tarih objesine çevirme
        const formattedDate = moment(timestamp).format('YYYY-MM-DDTHH:mm:ss');
        return formattedDate;
    };

    dateToTimestamp = (date) => {
        // Tarih objesini Unix timestamp'e çevirme
        const formattedDate = moment(date).unix();
        return formattedDate;
    };

    timestampMSToDate = (timestamp) => {
        // Unix timestamp'i tarih objesine çevirme
        const formattedDate = moment(timestamp * 1000).format('YYYY-MM-DDTHH:mm:ss');
        return formattedDate;
    };

    intToTimestamp = (intDate) => {
        // Tarihi string'e çevir ve moment.js ile parse et
        const dateMoment = moment(String(intDate), "YYYYMMDD");
        const unixTimestamp = dateMoment.unix();
        // Timestamp'e çevir (milisaniye cinsinden)
        return unixTimestamp;
    };

    intToTimestampChartFormat = (intDate) => {
        // Parse the input date (assuming YYYYMMDD format)
        let dateMoment = moment(String(intDate), "YYYYMMDD");

        // Return the Unix timestamp in milliseconds
        return dateMoment.valueOf();
    };

}

export default DateFormatter;